'use client';

import type { ButtonHTMLAttributes } from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'danger-soft';
export type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  block?: boolean;
  iconOnly?: boolean;
  loading?: boolean;
}

export function Button({
  variant = 'primary',
  size = 'md',
  block,
  iconOnly,
  loading,
  disabled,
  className,
  children,
  type = 'button',
  ...props
}: ButtonProps) {
  const cls = [
    'mx-btn',
    `mx-btn--${variant}`,
    size !== 'md' && `mx-btn--${size}`,
    block && 'mx-btn--block',
    iconOnly && 'mx-btn--icon',
    loading && 'mx-btn--loading',
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <button className={cls} type={type} disabled={disabled || loading} aria-busy={loading || undefined} {...props}>
      {children}
    </button>
  );
}
